// Tiny global store to register transient overlay close callbacks
// Usage:
//  const off = registerOverlayClose(() => setOpen(false));
//  return off; // in useEffect cleanup

const closers = new Set();

export function registerOverlayClose(fn) {
  if (typeof fn !== 'function') return () => {};
  closers.add(fn);
  return () => {
    try { closers.delete(fn); } catch {}
  };
}

export function closeAllOverlays() {
  // Copy to avoid mutation during iteration
  const current = Array.from(closers);
  for (const fn of current) {
    try { fn(); } catch {}
  }
}

export default { registerOverlayClose, closeAllOverlays };

